/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useContext } from "react"; // React Stuff
import { BrowserView, MobileView } from "react-device-detect"; // Device Detection for two views
import withRouter from "../WithRouter";
// Common
import FadeIn from "../common/FadeIn";
import ReturnButton from "../common/ReturnButton";
//TimeRendering
import Moment from "react-moment";
// Import global business context
import { BusinessContextConsumer } from "../BusinessContext.js";
//Packages
import axios from "axios";
import { Container, Tabs, Tab, Col, Row, Form, Button, Table } from "react-bootstrap";
import { isAuthenticatedTutor } from "./services/TutorAuth"; //import auth
import { Navigate, Link } from "react-router-dom";
//Subcomponents
import LoadingSpinner from "../LoadingSpinner";
import ClassIssueReports from "./page-parts/ClassIssueReports";

const SessionClass = (props) => {
  const [classData, setClassData] = useState({});
  const [viewMode, setViewMode] = useState("classinfo");
  // Extract the class ID
  const classid = props.params.classid;
  const prevClassId = useRef(); //Reference the previous class ID to ensure new get request if it changes.
  // Get the class data and set it
  useEffect(async () => {
    prevClassId.current = classid; // Assign Refs Value to current load
    // Get the Class Data
    const classDataRequest = await axios.get(`/api/tutor/manage/classes/${classid}`, {
      withCredentials: true,
    });
    return setClassData(classDataRequest.data);
  }, [classid]); // Run useEffect when the classID changes to get new class data.

  return (
    <div className='ClassList' key={classid}>
      <FadeIn delay={250} duration={450}>
        {isAuthenticatedTutor() ? (
          <Container>
            {classData._id ? (
              <>
                <BrowserView>
                  <Tabs defaultActiveKey='classinfo' id='uncontrolled-tabs' className='text-center'>
                    <Tab eventKey='classinfo' title='Overview'>
                      <ClassInfo data={classData} />
                    </Tab>
                    <Tab eventKey='progress' title='Progress &amp; Awards'>
                      <ClassIssueReports data={classData} />
                    </Tab>
                    <Tab eventKey='register' title='Registers'>
                      <ClassRegisterTab data={classData} />
                    </Tab>
                  </Tabs>
                </BrowserView>
                <MobileView>
                  <ModeSelect viewMode={viewMode} setViewMode={setViewMode} />
                  {viewMode === "classinfo" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassInfo data={classData} />
                    </FadeIn>
                  )}
                  {viewMode === "progress" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassIssueReports data={classData} />
                    </FadeIn>
                  )}
                  {viewMode === "register" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassRegisterTab data={classData} />
                    </FadeIn>
                  )}
                </MobileView>
                <Row>
                  <Col className='text-center' sm='12'>
                    <ReturnButton />
                  </Col>
                </Row>
              </>
            ) : (
              <LoadingSpinner />
            )}
          </Container>
        ) : (
          <Navigate to='/tutor/' />
        )}
      </FadeIn>
    </div>
  );
};

const ClassInfo = (props) => {
  // Handle Context
  const BusinessContext = useContext(BusinessContextConsumer);
  const { currencySymbol } = BusinessContext;
  //Get the props.
  const classinfo = props.data;

  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3'>
        <h1 className='mt-4'>Class Type: {classinfo.LessonType}</h1>
        <p>
          <strong>Venue</strong>: {classinfo.Venue.VenueName} at {classinfo.Venue.VenueAddress}.{" "}
        </p>
        <p>
          <strong>Time</strong>: {classinfo.StartTime} - {classinfo.FinishTime} on {classinfo.Day}
        </p>
        <p>
          <strong>Occupancy</strong>: {classinfo.Subscribers_Number} / {classinfo.MaxLearners}{" "}
        </p>
        <p>
          <strong>Waiting List Size</strong>: {classinfo.WaitingListSize}
        </p>
        <p>
          <strong>Description</strong>: {classinfo.ShortDescription}
        </p>
        <p>
          <strong>Price</strong>: {currencySymbol + parseFloat(classinfo.Price).toFixed(2)}
        </p>
        <p>
          <strong>Start Date</strong>: <Moment format='DD MMMM YYYY'>{classinfo.StartDate}</Moment>
        </p>
      </Col>
    </Row>
  );
};

const ClassRegisterTab = (props) => {
  return (
    <Row className='mt-5 mb-3 text-center'>
      <Col sm='12' className='border shadow p-3'>
        <h3 className='mt-4'>Registers</h3>
        <Button
          variant='primary'
          className='mb-3'
          as={Link}
          to={`/tutor/registers/${props.data.Current_Register}`}
        >
          Current Register
        </Button>
        <p>
          This is a list of your last six registers. Registers are automatically generated first day
          of the month for subscription model classes. Active, Paused and Past Due subscriptions are
          automatically added to new registers.
        </p>

        <Table striped bordered hover responsive className='text-center'>
          <thead>
            <tr>
              <th>Register Date</th>
              <th>View/Manage</th>
            </tr>
          </thead>
          <tbody>
            {props.data.Registers.sort(function (a, b) {
              return new Date(b.createdAt) - new Date(a.createdAt);
            }).map((Register) => (
              <tr key={Register._id}>
                <td className='align-self-center align-middle'>{Register.Register_Month}</td>
                <td className='align-self-center align-middle'>
                  <Button
                    variant='info'
                    size='sm'
                    type='link'
                    as={Link}
                    to={`/tutor/registers/${Register._id}`}
                  >
                    Manage
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};

const ModeSelect = (props) => {
  return (
    <Row>
      <Col>
        <Form className='mt-3 text-center'>
          <Form.Label>Choose Tab</Form.Label>
          <Form.Control
            as='select'
            value={props.viewMode}
            onChange={(e) => props.setViewMode(e.target.value)}
            custom
            className='border'
          >
            <option value='' disabled defaultValue>
              Select Option
            </option>
            <option value='classinfo'>Info</option>
            <option value='progress'>Progress &amp; Awards</option>
            <option value='register'>Registers</option>
          </Form.Control>
        </Form>
      </Col>
    </Row>
  );
};

export default withRouter(SessionClass);
